import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Settings from '../../assets/svgs/Settings';
import Sort from '../../assets/svgs/Sort';
import Search from '../../assets/svgs/Search';
import ToolbarModal from './ToolbarModal';
import SettingsBy from './SettingsBy';

const Toolbar = ({ className, onFilterChange, onSearch, setOrder, order }) => {
    const [showModal, setShowModal] = useState(false);
    const [openSearch, setSearchState] = useState(false);

    const showHandler = state => {
        setShowModal(state);
    };

    const handleFilter = filter => {
        onFilterChange(filter);
        setShowModal(false);
    };

    const SearchInputHandler = () => {
        setSearchState(!openSearch);
    };

    return (
        <>
            <div className={className}>
                <div className="Toolbar__Items">
                    <button
                        type="button"
                        onClick={() => {
                            setOrder(order === 'DESC' ? 'ASC' : 'DESC');
                            sessionStorage.setItem('order', order === 'DESC' ? 'ASC' : 'DESC');
                        }}
                    >
                        <Sort />
                    </button>
                    <button type="button" onClick={() => setShowModal(true)}>
                        <Settings />
                    </button>
                </div>
                <div className="Toolbar__Search">
                    <input
                        className={`${openSearch ? 'isOpen' : 'isClose'} `}
                        type="text"
                        placeholder="متن مورد نظر خود را تایپ کنید"
                        onChange={event => onSearch(event.target.value)}
                    />
                    <button type="button" onClick={SearchInputHandler}>
                        <Search />
                    </button>
                </div>
            </div>
            <ToolbarModal
                component={SettingsBy}
                show={showModal}
                onModalChange={showHandler}
                onFilterChange={handleFilter}
            />
        </>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    setOrder: PropTypes.func.isRequired,
    order:PropTypes.string.isRequired,
};

export default styled(Toolbar)`
    display: flex;
    flex-flow: row-reverse;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .Toolbar__Items {
        display: flex;
        align-items: center;
    }

    button {
        background: none;
        padding: 10px;
        border: none;
    }

    .Toolbar__Search button {
        position: relative;
    }

    .Toolbar__Search input {
        background: rgba(255, 255, 255, 1);
        border-radius: 17px;
        border: none;
        box-shadow: 0 3px 10px rgba(232, 235, 255, 1);
        position: absolute;
        top: 4px;
        right: 0;
        width: 100%;
        font-size: 12px;
        color: rgba(188, 195, 242, 1);
        font-weight: 300;
        line-height: 21px;
        width: 0%;
        padding: 0;
        transition: width 150ms 0 ease-out, padding 1ms 150ms ease;

        &.isOpen {
            width: 100%;
            padding: 6px 42px 6px 15px;
            transition: width 150ms 0 ease-out, padding 1ms 0ms ease;
        }
    }
`;
